///
///
/// This applies to "score based" recaptcha only. For checkbox challenge, use recaptcha v1.
///

(function() {
  const formElement = document.querySelector('form.cmp-form');
  const formRecaptchaHiddenElement = formElement.querySelector('input[data-cmp-form-recaptchaV2]');
  const recaptchaScorekey = formRecaptchaHiddenElement.getAttribute('data-cmp-form-recaptchaV2-key');
  const recaptchaScoreAction = formRecaptchaHiddenElement.getAttribute('data-cmp-form-recaptchaV2-action');
 
  formElement.addEventListener('submit', async function(e){
    e.preventDefault();
    const recapResult = await grecaptcha.enterprise.execute(recaptchaScorekey, {action: recaptchaScoreAction});
    if (recapResult) {
      formRecaptchaHiddenElement.value = recapResult;
      this.submit();
    }
  });
})();